import { createActions, createReducer } from 'reduxsauce'

import AdministracaoService from '_/servicos/AdministracaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAdministracaoInicio: [],
    buscaAdministracaoSucesso: ['administracao'],
    buscaAdministracaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAdministracao = () => {
    return dispatch => {
        dispatch(Creators.buscaAdministracaoInicio())
        let serv = new AdministracaoService()
        return serv
            .getAdministracao()
            .then(response => dispatch(Creators.buscaAdministracaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAdministracaoErro(error)))
    }
}

const buscaAdministracaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAdministracaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaAdministracaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.administracao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ADMINISTRACAO_INICIO]: buscaAdministracaoInicio,
    [Types.BUSCA_ADMINISTRACAO_ERRO]: buscaAdministracaoErro,
    [Types.BUSCA_ADMINISTRACAO_SUCESSO]: buscaAdministracaoSucesso,
})
